import { Controller } from '@hotwired/stimulus';
import AutoNumeric from 'autonumeric';
import { ConfiguracionPrecio } from '../../../../libs/autonumeric';

export default class extends Controller {
  connect() {
    this.importesNegativos = this.element.dataset.importesNegativos === 'true';

    this.selectIva = this.element.querySelector('.iva');
    this.selectIva.addEventListener('change', () => {
      this.#actualizarPvp();
    });

    const inputBaseImponible = this.element.querySelector('.base-imponible');
    // Hay cálculos que si no tenemos 3 decimales no se pueden hacer como por ejemplo
    // poner un importe final de 38€ con 21% de IVA (nos pondría 37.99 si solo tenemos
    // dos decimales)
    this.autoNumericBaseImponible = this.#inicializarAutonumeric(inputBaseImponible, 3);

    this.inputPvp = this.element.querySelector('.pvp');
    this.autoNumericPvp = this.#inicializarAutonumeric(this.inputPvp);

    inputBaseImponible.addEventListener('keyup', () => {
      this.#actualizarPvp();
    });
    this.inputPvp.addEventListener('keyup', () => {
      this.#actualizarBaseImponible();
    });

    if (inputBaseImponible.value && !this.inputPvp.value) {
      this.#actualizarPvp();
    }

    this.#conectarInputsUnidades();
  }

  #conectarInputsUnidades() {
    this.inputUnidades = this.element.querySelector('.unidades');
    this.inputPvpTotal = this.element.querySelector('.pvp-total');
    if (!this.inputUnidades || !this.inputPvpTotal) return;

    this.autoNumericinputPvpTotal = this.#inicializarAutonumeric(this.inputPvpTotal);
    this.inputUnidades.addEventListener('change', () => {
      this.#actualizarPvpTotal();
    });
    this.#actualizarPvpTotal();
  }

  #inicializarAutonumeric(input, decimales) {
    const configuracion = {
      unformatOnSubmit: true,
      decimalPlaces: decimales || 2,
      ...ConfiguracionPrecio,
    };

    if (this.importesNegativos) {
      configuracion.maximumValue = '0.00';
      configuracion.minimumValue = '-9999999999.00';
    }

    return new AutoNumeric(input, configuracion);
  }

  #actualizarPvp() {
    let valor = this.autoNumericBaseImponible.getNumber();
    valor = valor || 0;
    valor *= 1 + (this.#getValorIva() / 100);
    this.autoNumericPvp.set(valor);
    this.#actualizarPvpTotal();
  }

  #actualizarBaseImponible() {
    let valor = this.autoNumericPvp.getNumber();
    valor = valor || 0;
    valor /= 1 + (this.#getValorIva() / 100);
    this.autoNumericBaseImponible.set(valor);
    this.#actualizarPvpTotal();
  }

  #getValorIva() {
    let iva = 0;
    if (this.selectIva.selectedOptions.length > 0) {
      iva = this.selectIva.selectedOptions[0].dataset.iva || 0;
    }
    return iva;
  }

  #actualizarPvpTotal() {
    if (!this.inputPvpTotal) return;

    this.autoNumericinputPvpTotal.set(this.autoNumericPvp.getNumber() * this.inputUnidades.value);
  }
}
